import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  CtButtonConfiguration,
  CTGeneralService,
  CtModelConfiguration,
  MAT_RAISED_PRIMARY
} from "@ctsolution/ct-framework";
import { CTMGeneralService } from '../../_core/lib/general.service';
import { JwtService } from '../../_core/lib/jwt.service';
import { CtWebapiGenericResponse } from "@ctsolution/ct-webapi";
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { UserRouteData } from '../../_core/route-data/user.route-data';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  profileForm: FormGroup;
  isLoading = true;
  isSaving = false;
  userOid: number | null = null;
  originalProfileData: any = null;

  saveButton: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("Salva modifiche")
    .setAction(() => this.submit())
    .setMatherialOptions(MAT_RAISED_PRIMARY);

  constructor(
    private CTGeneralService: CTGeneralService,
    private generalService: CTMGeneralService,
    private jwtService: JwtService,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar
  ) {
    this.profileForm = this.formBuilder.group({
      Name: ['', Validators.required],
      Surname: ['', Validators.required]
    });
  }

  async ngOnInit() {
    await this.loadProfile();
  }

  async loadProfile() {

    this.isLoading = true;

    try {

      const userOid = await this.jwtService.getUserInfoOid();

      if (!userOid) {
        console.error('Impossibile recuperare l\'OID dell\'utente');
        this.isLoading = false;
        return;
      }

      this.userOid = +userOid;

      const response: CtWebapiGenericResponse<any> = await this.generalService
        .getInfos({
          controller: 'User',
          oid: this.userOid
        })
        .toPromise();

      const profileData = response?.Result?.DataSource;

      if (profileData) {
        this.originalProfileData = profileData;

        this.profileForm.patchValue({
          Name: profileData.Name || '',
          Surname: profileData.Surname || ''
        });
      }

    } catch (error) {
      console.error('Errore durante il caricamento del profilo:', error);
    } finally {
      this.isLoading = false;
    }

  }

  async submit() {

    this.profileForm.markAllAsTouched();

    if (this.profileForm.valid) {

      this.isSaving = true;

      const formValues = this.profileForm.getRawValue();

      const dataToSend = {
        ...this.originalProfileData,
        Name: formValues.Name,
        Surname: formValues.Surname
      };

      const configuration = CtModelConfiguration
        .create()
        .setRouteData(
          UserRouteData().setId(this.userOid!)
        );

      try {

        await this.generalService.putData(configuration, dataToSend);

        this.showSuccessMessage('Profilo aggiornato con successo');

        await this.loadProfile();

      } catch (error) {
        console.error('Errore durante il salvataggio:', error);
        this.showErrorMessage('Errore durante il salvataggio del profilo');
      } finally {
        this.isSaving = false;
      }

    }

  }

  hasError(fieldName: string, errorType: string): boolean {
    const field = this.profileForm.get(fieldName);
    return !!(field?.hasError(errorType) && (field?.dirty || field?.touched));
  }

  private showSuccessMessage(message: string): void {
    this.snackBar.open(message, 'Chiudi', {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['success-snackbar']
    });
  }

  private showErrorMessage(message: string): void {
    this.snackBar.open(message, 'Chiudi', {
      duration: 7000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['error-snackbar']
    });
  }

}
